<template>
    <a :href="`${baseUrl}/${product.slug}`" target="_self" title="" class="product-box">
        <img v-if="product.action" :src="`${baseUrl}/images/sale.png`" class="sale-image" alt="sale" />
        <div v-if="product.showCartRule" class="free-shipping coupon-label" v-html="product.cartRuleLabel" :style="`background-color: ${product.cartRuleLabelBgColor}; color: ${product.cartRuleLabelColor};`"></div>
        <div v-if="product.freeShipping" class="free-shipping" v-bind:class="[ product.action ? 'with-sale' : '', product.showCartRule ? 'with-coupon-label' : ''  ]">{{ __('products.free-shipping') }}</div>
        <div v-if="product.discontinued" class="free-shipping" v-bind:class="[ product.action ? 'with-sale' : '', product.showCartRule ? 'with-coupon-label' : ''  ]">{{ __('products.discontinued.label') }}</div>
        <div class="img" :style="`background-image: url('${product.image}');`"></div>
        <div class="text d-flex flex-column justify-content-between flex-grow-1">
            <div>
                <h2>{{ product.name }}</h2>
            </div>
            <div>
                <div>
                    <p class="price"  v-html="product.priceHTML"></p>
                </div>
                <div style="height: 46px;">
                    <span v-if="product.stock > 0"
                          v-bind:class="[product.stock <= 0 ? outOfStockClass : inStockClass]"
                          class="status mt-3 px-auto w-100 text-center d-block"
                    >{{ __('productbox.in_stock.text') }}: {{ product.stock }} {{ __('index.unit_label') }}</span>
                    <span v-else
                          v-bind:class="[product.stock <= 0 ? outOfStockClass : inStockClass]"
                          class="status mt-3 px-auto w-100 text-center d-block"
                          v-html="product.purchaseTime"
                    ></span>
                </div>
                <div class="text-center">
                    <a :href="`${baseUrl}/${product.slug}`" target="_self" title="" class="btn-burgundy mt-4">{{ __('productbox.details.text') }}</a>
                </div>
            </div>
        </div>
    </a>
</template>

<script type="text/javascript">
    export default {
        props: [
            'list',
            'featured',
            'product',
        ],

        data: function () {
            return {
                'inStockClass': 'status--instock',
                'outOfStockClass': 'status--outofstock',
                'addToCart': 0,
                'addToCartHtml': '',
            }
        },

        methods: {
            'isMobile': function () {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>
